// @ts-nocheck

import { setFavoritePopupCont } from "~/ui/markerinfo";
import { isMapycz } from "./utils";

/* eslint-disable */
export function getMelownCard() {
	/**
	 * Vlastni obal pro ziskani vizitky pro 3d. Je to trosku ochcane v tom, ze se pouziji stejne metody jako pro mapu,
	 * znacce ve 3d se da trida smap a dodrzi se cela ta hierarchie, aby znacka vypadal stejne.
	 */
	let Melown3dCard = function() {};

	/**
	 * Pokud to volame pro /map3d, tak Mapy neni ve window
	 */
	if (isMapycz()) {
		Melown3dCard.prototype = Object.create(Object.assign({}, Mapy.MarkerCard.prototype));
	}

	/**
	 * Bind karty.
	 *
	 * @param  {Element}  el Kam vizitku pripnout?
	 * @param  {Object}  poi Vstupni data pro vizitku. Bude se volat description
	 * @param  {Boolean} [isDetail = false] Jedna se o vizitku pro detail?
	 * @return {Object} Promise s hotovou kartou a callbackem, ktery se vola pri zavreni karty.
	 */
	Melown3dCard.prototype.bindCard = function(el, poi, isDetail) {
		let output = {
			promise: new JAK.Promise(),
			removeCardCb: () => {}
		};
		let card = {
			getBody: function() {
				return el;
			}
		};

		if (poi?.m3dType === "favorite") {
			setFavoritePopupCont({
				card,
				item: poi,
				opts: {
					cardClick: () => {
						if (typeof poi.m3dData?.click === "function") {
							poi.m3dData.click();
						}
					},
				},
				onCardRemove: () => {
					output.removeCardCb();
				},
				showParentInfo: true,
			});

			output.promise.fulfill();
		} else {
			this._getDesc(poi).then(function(desc) {
				this._setPopupCont(card, desc, isDetail, () => {
					output.removeCardCb();
				});

				output.promise.fulfill();
			}.bind(this), function() {});
		}

		return output;
	}

	return new Melown3dCard();
}
